import { supabaseAuth } from './supabaseClient';
import { getHubToken } from './hubAuth';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

/**
 * Authenticated fetch wrapper. Automatically attaches the auth token.
 * Priority: hub token (from customer portal) > Supabase session token.
 */
export async function authFetch(url, options = {}) {
  // Prefer hub token if launched from customer portal
  let token = getHubToken();

  // Fallback to local Supabase session
  if (!token) {
    const { data: { session } } = await supabaseAuth.auth.getSession();
    token = session?.access_token;
  }

  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {}),
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  return fetch(url, { ...options, headers });
}
